import * as Yup from 'yup'

export const conselhoSchema = Yup.object().shape({
  nome: Yup.string().trim().required('Nome é obrigatório'),
  sigla: Yup.string().trim().required('Sigla é obrigatório'),
})
